import {
    ThemeProvider as MuiThemeProvider,
    Theme,
} from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import React from 'react';
import emotionStyled from '@emotion/styled';

// Exposes the injected properties allows us to
// prevent fullstory from injecting invalid props to theme providers
// which prints out an error
interface WireProps {
    children: (props: unknown) => React.ReactElement;
}

function Wire({ children, ...props }: WireProps) {
    return children(props);
}

interface ThemeProviderProps {
    theme: Theme;
    children: React.ReactNode;
}

export const ThemeProvider = ({ theme, children }: ThemeProviderProps) => (
    <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <Wire>
            {(props) => <>{children}</>}
        </Wire>
    </MuiThemeProvider>
);

export const styled = emotionStyled;
